/**
 * Read the application configuration directly.
 */
let { app } = window.beesfra || {};
if (!app) {
  app = {};
}
const appConfig = app;
export default appConfig;
